export default __webpack_public_path__ + "static/media/banner-2.e4a88ff1.webp";